import axios from '../../axios/index.js'

export default {
  getList(data) {
    return axios.get('/load_order/list', { params: data })
  },
  getDetails(id) {
    return axios.get('/load_order/getDetails/' + id)
  },
  getInvoices(id) {
    return axios.get('/load_order/getInvoices/' + id)
  },
  getFiles(id) {
    return axios.get('/load_order/getFiles/' + id)
  },
  getTimeline(id) {
    return axios.get('/load_order/getTimeline/' + id)
  },
  updateLoadOrder(data) {
    return axios.post('/load_order/update', data)
  },
  store(data) {
    return axios.post('/load_order/store', data)
  },
  getBadget() {
    return axios.get('load_order/badget')
  },
  getTrailers(data) {
    return axios.get('load_order/getTrailer', { params: data })
  },
  getTransporters() {
    return axios.get('load_order/getTransporter')
  },
  getReviewOrders(id) {
    return axios.get('/load_order/getReviewOrders/' + id)
  },
  getReviewOrderInvoices(data) {
    return axios.post('/load_order/getReviewOrderInvoices', data)
  },
  addTrailer(data) {
    return axios.post('/load_order/add_trailer', data)
  },
  trailerTypes() {
    return axios.get('load_order/trailer_types')
  },
  getSign(id) {
    return axios.get('load_order/getsign/' + id)
  }
}
